<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/usuarios`;
const token = utilsService.getToken();

const userService = {
  // Nombres de varios usuarios en una sola llamada, a partir de sus ids. Lo usa la analitica,
  // que recibe ids desde Mongo: pedirlos de a uno seria una consulta por fila en pantalla.
  // El token se toma al llamar y no al importar el modulo, que es lo que hace el resto de
  // este archivo: asi no queda pegado a la sesion que estaba activa al cargar el bundle.
  async getNombres(ids) {
    const lista = (ids || []).filter(x => x !== null && x !== undefined && x !== '');
    if (!lista.length) return [];
    try {
      const response = await axios.get(`${apiUrl}/nombres`, {
        params: { ids: lista.join(',') },
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data || [];
    } catch (error) {
      console.error('[userService.getNombres]', error.message);
      return [];
    }
  },

  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async getPerfil(id) {
    try {
      const response = await axios.get(`${apiUrl}/perfil/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async getRolesOptions() {
    try {
      const response = await axios.get(`${apiUrl}/roles/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getKamOptions() {
    try {
      const response = await axios.get(`${apiUrl}/kam/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
  async create(formRaw) {
  try {
    const form = { ...formRaw };
    form.idRol = form.idRol || 0;
    form.idZona = form.idZona || 0;

    const response = await axios.post(`${apiUrl}/create`, form, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    // 🔴 No envolver el error con new Error(...)
    // Si viene de Axios, re-lanzar tal cual para conservar response.status y response.data
    if (error && error.response) {
      throw error;
    }
    // Fallback: construir un objeto "tipo Axios" para que el caller lo maneje igual
    throw {
      response: {
        status: 0,
        data: (error && error.message) ? error.message : 'Error en la solicitud.'
      }
    };
  }
},


  async update(formRaw, id) {
    try {
      const form = { ...formRaw };
      form.idRol = form.idRol || 0;
      form.idZona = form.idZona || 0;

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el usuario.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async updatePass(password, id) {
    try {
      const response = await axios.put(`${apiUrl}/${id}/password`, JSON.stringify(password), {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  // Alta/baja logica del usuario. La baja es reversible: `activo = true` lo reactiva.
  async cambiarEstado(id, activo) {
    const response = await axios.patch(`${apiUrl}/${id}/estado`, { activo }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.status;
  }
};

export default userService;
</script>
